function isVariantAddOnInCart(variantId){
  return window.SideCart ? window.SideCart.isVariantIdInCart(variantId) : false;
}

function getGalleryItems(string_urls){
  var urls = string_urls.replace(/\s/g, '').split(',');
  var gallery_html = "";
  urls.forEach(function(image_url){
    gallery_html += `
    <div class="item swiper-slide">
      <div class="image-wrapper"><img class="lazyload" data-sizes="auto" data-src="${$s.imgUrlFilter(image_url, '360x')}360w, ${$s.imgUrlFilter(image_url, '540x')} 540w, ${$s.imgUrlFilter(image_url, '720x')} 720w, ${$s.imgUrlFilter(image_url, '900x')} 900w" alt="" /></div>
    </div>
    `
  })
  return gallery_html;
}

function checkGalleryQuantity(string_urls) {
    const imagesCount = string_urls.replace(/\s/g, '').split(',').length;
    let arrowsHtml = '';

    if (imagesCount > 0 ) {
        arrowsHtml = `
        <div class="keen-arrows">
        <button class="keen-arrow prev" aria-label="Go to previous slide">
        <svg aria-hidden="true" tabindex="-1" role="presentation" class="icon icon-arrow-long-left" viewBox="0 0 32 32"><path fill="#502c1e" d="M0,16,7.9,8.1,9.3,9.4,3.6,15.1H32v1.8H3.6l5.7,5.7L7.9,23.9Z">
            <path fill="#502c1e" d="M0,16,7.9,8.1,9.3,9.4,3.6,15.1H32v1.8H3.6l5.7,5.7L7.9,23.9Z"></path>
        </svg>
        </button>
        <button class="keen-arrow next" aria-label="Go to next slide">
        <svg aria-hidden="true" tabindex="-1" role="presentation" class="icon icon-arrow-long-right" viewBox="0 0 32 32">
            <path fill="#502c1e" d="M32,16l-7.9,7.9-1.4-1.3,5.7-5.7H0V15.1H28.4L22.7,9.4l1.4-1.3Z"></path>
        </svg>
        </button>
        </div>
        `
    }
    return arrowsHtml;
}

async function showCrossUpSellPopup(formData, params, submitHandler) {
  var data = Object.fromEntries(formData);
  function getSourceFormItems(data) {
    var items = [];
    if (data.id) {
      var properties = {};
      for (key in data) {
        if (key.startsWith('properties[')) {
          properties[key.replace('properties[','').replace(']','')] = data[key];
        }
      }
       items.push({id: data.id, quantity: data.quantity || 1, properties: properties})
      
    } else {
      var properties = {};
      for (key in data) {
        if (key.startsWith('items[')) {
          var index = key.split('][')[0].split('[')[1];
          var attribute = key.split('][')[1].slice(0, -1);
          if (!items[index]) {
            items[index] = {quantity: data.quantity || 1, properties: {}}
          }
          if (attribute=='id') {
            items[index].id = data[key];
          } else if (attribute.indexOf('properties[')==0) {
            var prop = attribute.slice(11, -1);
            items[index].properties[prop] = data[key];
          }
        }
      }

    }
    return items;
  }

  var config = params.dataset;
  var htmlItems = '';
  var itemsQuantity = 0;
  var formContainer = null;
  var useProductButton = config.crosssellProductAddButton=='true' && config.crosssellAllowMultipleSelection!='true';
  var variantOptions = [];
  var sourceItems = getSourceFormItems(data);

  for (var dataProp in data) {
    if (dataProp.indexOf('swatch-')==0) {
      variantOptions.push(data[dataProp]);
    }
  }

  //
  var variantsTargetMap = JSON.parse(config.variantsTarget);
  var html = ``;

  if(config.crosssellProductHiddenVariantId){
    // When the product is hidden from online store we can't get the product data, instead we just use the variant id
    itemsQuantity++;
    var popupTitle = "Special Offer";
    var crossSelVariantId;
    if(sourceItems[0].properties.shipping_interval_frequency && config.crosssellSubscriptionHiddenVariantId){
      crossSellVariantId = config.crosssellSubscriptionHiddenVariantId;
      config.crosssellDuplicateProperties = true;
    }else{
      crossSellVariantId = config.crosssellProductHiddenVariantId;
    }

    html = `
      <div class="cross-up-sell-form">
        <input type="checkbox" id="chk-cross-up-sell" class="checkbox-custom input-include" value="${crossSellVariantId}" />
        <div class="title h2 text-center">${popupTitle}</div>
        <div class="subtitle text-center">${config.crosssellPopupSubtitle}</div>
        <div class="grid align-items-center">
          <div class="grid-item large--one-half one-whole">
            <div class="product-gallery">
              <div class="swiper"><div class="swiper-wrapper">${getGalleryItems(config.crosssellPopupImages)}</div></div>
              ${checkGalleryQuantity(config.crosssellPopupImages)}
            </div>
          </div>
          <div class="grid-item large--one-half one-whole">
            <div class="flex medium-down--justify-content-end large--direction-column large--align-items-start medium-down--row-reverse medium-down--align-items-center">
              <div class="badge">${config.crosssellPopupSavingBadgeText}</div>
              <div class="price">
                <span class="retail">${config.crosssellPopupCompareAtPrice}</span>
                <span class="deal">${config.crosssellPopupPrice}</span>
              </div>
            </div>
            
            <div class="text">${config.crosssellPopupText}</div>
            <div class="actions flex-wrap">
              `+ (!useProductButton ? `<button type="button" class="btn btn-yes one-whole small--one-whole">Add to order</button>` : ``)+`
              <button type="button" class="btn v2 btn-no one-whole small--one-whole">No thanks, continue to cart</button>
            </div>
          </div>
        </div>
      </div>
    `;

  }else{
    var products = await $s.getProducts(config.productHandles.split(','));
    for (var handle in products) {
      if (products[handle] && products[handle].available) {
        var product = products[handle];
        itemsQuantity++;
      //variant matching
      var variant = null;
      if (variantsTargetMap[''+sourceItems[0].id]) {
        variant = product.variants.find((x)=>x.id==variantsTargetMap[''+sourceItems[0].id]);
      }

      if (variant == null) {
        //match variant with same options values
        variant = product.variants.find((x)=>{
          return x.options.length==variantOptions.length
            && x.options.every((val, index) => val === variantOptions[index]);
        });

      }

      if (variant == null) {
        //if no match, use the first available variant
        variant = product.variants.find((x)=>x.available);
      }

      var inputControl = '';
      if (config.crosssellAllowMultipleSelection=='true') {
        inputControl = `<input type="checkbox" id="chk-cross-up-sell-${handle}" class="checkbox-custom input-include" value="${variant.id}" />
        <label for="chk-cross-up-sell-${handle}" class="checkbox-custom-label flex"><div class="span">Include</div></label>`;
      } else {
        inputControl = `<input type="radio" name="cross-up-sell-selector" id="chk-cross-up-sell-${handle}" class="radio-custom input-include" value="${variant.id}" />
        <label for="chk-cross-up-sell-${handle}" class="radio-custom-label flex"><div class="span">Include</div></label>`;
      }
      var imageUrl = variant.featured_image ? variant.featured_image.src : product.images[0];
        var item = `
          <div class="item swiper-slide">
          <div class="image-wrapper"><img class="lazyload" data-sizes="auto" data-src="${$s.imgUrlFilter(imageUrl, '360x')}360w, ${$s.imgUrlFilter(imageUrl, '540x')} 540w, ${$s.imgUrlFilter(imageUrl, '720x')} 720w, ${$s.imgUrlFilter(imageUrl, '900x')} 900w" alt="" /></div>
            <div class="title">${product.title}</div>
          <div class="price">${$s.formatMoney(variant.price).replace('.00', '')}</div>
            ${inputControl}
            `+ (useProductButton ? `<button type="button" class="btn btn-select">Add to Order</button>` : ``)+`
          </div>
        `;
        htmlItems += item;
      }
    }

    html = `
    <div data-items-quantity="${itemsQuantity}" class="cross-up-sell-form `
      + (config.crosssellAllowMultipleSelection=='true' ? 'multiple-selection' : 'single-selection') 
      + (useProductButton ? ' product-button' : '') 
      + ' mode-' + config.mode
      + (config.crosssellGwp=='true' ? ' is-gwp' : '') 
      + `">
      <div class="message"></div>
      <div class="items swiper"><div class="swiper-wrapper">${htmlItems}</div></div>
      ${checkGalleryQuantity(config.crosssellPopupImages)}
      </div>
      <div class="actions">
        `+ (!useProductButton ? `<button type="button" class="btn btn-yes one-half small--one-whole">Add</button>` : ``)+`
        <button type="button" class="btn v2 btn-no one-half small--one-whole">No thanks, continue to cart</button>
      </div>
    </div>`;
  }

  if (itemsQuantity==0) {
    submitHandler(formData);
    return; //no products available
  }

 
  
  var answer = ''; // default value on close, '' to do nothing, 'no' to add original data on close
  async function onModalClose() {
  
    if (answer=='no' || !answer) {
      submitHandler(formData);
    } else if(answer=='yes') {
      //get id, quantity and properties of original item/s;
      var quantity = data.quantity || 1;
      var items = JSON.parse(JSON.stringify(sourceItems)); //deep copy
      var newIds = [];
      document.querySelectorAll('.cross-up-sell-form .input-include:checked').forEach(function(chk) {
        newIds.push(chk.value);
      })
      if (config.mode=='up') {
        items[0].id = newIds[0]
      } else {
        var isBundle = config.crosssellMakeBundle=='true';
        var crossQuantity = isBundle && config.crosssellGwp!='true' ? items[0].quantity : 1;
        var crossProperties = config.crosssellDuplicateProperties=='true' ? Object.assign({}, items[0].properties) : {};
        var newItem = {id: 'TODO: newid cross', quantity: crossQuantity};
        if (isBundle) {
          items[0].properties = items[0].properties || {};
          var bundleId = items[0].properties['_bundle_id'] || Math.floor(Math.random()*8999+1000) + new Date().toISOString().match(/[0-9]/g).join('');
          if (!items[0].properties['_bundle_id']) {
            items[0].properties['_bundle_id'] = bundleId;
            items[0].properties['_bundle_item'] = 'main';
          }
          crossProperties['_bundle_id'] = bundleId;
          crossProperties['_bundle_item'] = config.crosssellGwp=='true' ? 'related_single' : 'related_multiple';
          if (config.discountCode) {
            crossProperties['_discount_code'] = config.discountCode;
          }

        }
        if (config.crosssellProperties) {
            var jsonProps = JSON.parse(config.crosssellProperties);
            Object.assign(crossProperties, jsonProps);
        }
        newItem['properties'] = crossProperties;
        newIds.forEach(function(id) {
          var item = Object.assign({}, newItem);
          item.id = id;
          items.push(item);
        })
      }
      submitHandler({"items": items});
    }
    answer = '';
  }

  // if the sku is already added, we don't need to show the modal
  if(config.crosssellProductHiddenVariantId && isVariantAddOnInCart(config.crosssellProductHiddenVariantId)
      && !(config.discountCode && config.redirectToCheckout)){
    submitHandler(data); 
    return false;
  } 

  $s.closeModal();
  var modal = $s.openModal(html, 'cross-up-sell-modal', {close: onModalClose});
  formContainer = document.querySelector('.cross-up-sell-form');
  
  var sliderWrapper = formContainer.querySelector('.swiper');
  var desktopSpv = (config.crosssellProductHiddenVariantId) ? 1 : 3;
  function initCrossSellSwiper() {
    if (typeof Swiper === 'undefined') {
      window.addEventListener('swiper:ready', initCrossSellSwiper, { once: true });
      return;
    }
    var prevEl = formContainer.querySelector('.keen-arrow.prev');
    var nextEl = formContainer.querySelector('.keen-arrow.next');
    var slideCount = sliderWrapper.querySelectorAll('.swiper-slide').length;
    var opts = {
      centeredSlides: true,
      slidesPerView: 1,            // Keen max-width medium/small bands both = 1
      spaceBetween: 20,
      breakpoints: {
        901: { slidesPerView: desktopSpv }   // Keen desktop base (hidden-variant=1, else 3)
      }
    };
    // Swiper loop needs enough slides to clone; otherwise rewind.
    if (slideCount > 2 * desktopSpv) { opts.loop = true; } else { opts.rewind = true; }
    if (prevEl && nextEl) opts.navigation = { prevEl: prevEl, nextEl: nextEl };
    new Swiper(sliderWrapper, opts);
  }
  initCrossSellSwiper();

  function actionNo() {
    answer = 'no'
    modal.close();
  }
  function actionYes() {
    if (formContainer.querySelectorAll('.input-include:checked').length == 0) {
      if (itemsQuantity==1) {
        formContainer.querySelector('.input-include').checked = true;
      } else {
        //must select one product
        return false;
      }
    }

    if (config.redirectToCheckout=='true') {
      //automatically redirect to checkout
      var origSuccess = $s.addToCartSuccess;
      var origFail = $s.addToCartFail;
      $s.addToCartSuccess = function() {
        restoreCallbacks();
        $s.checkout(null, config.discountCode);
      };
      $s.addToCartFail = function() {
        restoreCallbacks();
        $s.addToCartFail.apply(this, arguments);
      }
      function restoreCallbacks() {
        $s.addToCartSuccess = origSuccess;
        $s.addToCartFail = origFail;
      }
    }

    answer = 'yes';
    modal.close();
    return true;
  }
  var elMessage = formContainer.querySelector('.message');
  var btnNo = formContainer.querySelector('.btn-no');
  var btnYes = formContainer.querySelector('.btn-yes');
  var btnsSelect = formContainer.querySelectorAll('.btn-select');
  var chksInclude = formContainer.querySelectorAll('.input-include');

  if(elMessage) elMessage.innerHTML = config.message;
  btnNo.addEventListener('click', actionNo);
  if (btnYes) {
    btnYes.addEventListener('click', actionYes);
  }
  btnsSelect.forEach(function(btn) {
    btn.addEventListener('click', function() {
      btn.closest('.item').querySelector('.input-include').checked = true;
      actionYes();
    })
  });
  chksInclude.forEach(function(chk) {

  });

  //modal opened, all ready
  $s.hideLoadingOverlay();
  if (config.crosssellGwp=='true') {
    //automatically add product if possible (one and only one item exists for the cross sell), otherwise continue without adding.
    if (!actionYes()) {
      actionNo();
    }
  }
}

